/* eslint-disable id-length */
import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/system';
import dayjs from 'dayjs';
import SearchDropdown from '../Dropdown/dropdown';
import './dateRangePicker.scss';

const CustomCalendarHeader = ({
  currentMonth,
  onMonthChange,
}) => {
  const [selectedMonth, setSelectedMonth] = React.useState(currentMonth.month());
  const [selectedYear, setSelectedYear] = React.useState(currentMonth.year());

  const monthOptions = Array.from({ length: 12 }, (_, index) => ({
    id: index,
    name: dayjs().month(index)
      .format('MMMM'),
  }));

  const yearOptions = Array.from({ length: dayjs().year() - 1980 + 1 }, (_, index) => {
    const year = 1980 + index;
    return { id: year, name: year.toString() };
  });

  const handleMonthChange = (event) => {
    const newMonth = event.target.value.id;
    setSelectedMonth(newMonth);
    onMonthChange(currentMonth.set('month', newMonth), 'left');
  };

  const handleYearChange = (event) => {
    const newYear = event.target.value.id;
    setSelectedYear(newYear);
    onMonthChange(currentMonth.set('year', newYear), 'left');
  };

  return (
    <div className="date-range-picker-header">
      <Stack spacing={1} direction="row" className="date-range-picker-stack">
        <SearchDropdown
          options={monthOptions.map((option) => ({
            ...option,
          }))}
          onChange={handleMonthChange}
          value={monthOptions.find((option) => option.id === selectedMonth)}
          dropdownCss="month-dropdown"
        />
        <SearchDropdown
          options={yearOptions}
          onChange={handleYearChange}
          value={yearOptions.find((option) => option.id === selectedYear)}
          dropdownCss="year-dropdown"
        />
      </Stack>
    </div>
  );
};

CustomCalendarHeader.propTypes = {
  currentMonth: PropTypes.object.isRequired,
  onMonthChange: PropTypes.func.isRequired,
};

export default CustomCalendarHeader;
